import getDataProgram from "./form/getDataProgram";
import { modal } from "./modal/init-modal";

const quiz = (requestPrograms, programs) => {
  const quiz = document.querySelector("[data-quiz]");
  if (!quiz) return;

  const btnsPrevSlide = document.querySelectorAll(".quiz__slide-switches__back"),
    btnsNextSlide = document.querySelectorAll(".quiz__slide-btn"),
    slides = document.querySelectorAll(".quiz__slide");

  if (btnsPrevSlide.length < 1) {
    return;
  }

  /* */
  let level = "",
    region = "",
    allProgramsRegionFiltred = [],
    filterNoDublicatePrograms = [],
    filterPrograms = [],
    allProgramsRegion = [];

  /* Блокируем по умолчанию первую кнопку "Назад" в квизе */
  btnsPrevSlide[0].disabled = true;

  /* Переключение через кнопку "Назад" */
  (function PrevSlide() {
    for (let i = 0; i < btnsPrevSlide.length; i++) {
      btnsPrevSlide[i].addEventListener("click", () => {
        slides[i].style.display = "none";
        slides[i - 1].style.display = "flex";
      });
    }
  })();

  /* Переключение через кнопку "Далее" */
  const nextSlide = (form) => {
    form
      .closest(".quiz__slide")
      .querySelector(".quiz__slide-btn").disabled = false;

    setTimeout(() => {
      form.closest(".quiz__slide").style.display = "none";
      let number = +form.closest(".quiz__slide").getAttribute("data-number");
      slides[number + 1].style.display = "flex";
      resetCheked(number + 1);
    }, 500);
  };

  /* переключение на кнопку Далее */
  for (let i = 0; i < btnsNextSlide.length; i++) {
    btnsNextSlide[i].addEventListener("click", () => {
      /* Срабатывание метрики на конпку "Далее" на конкретном слайде */
      let slide_name = btnsNextSlide[i].closest(".quiz__slide").getAttribute("data-slide");

      if (slide_name) {       
        switch (slide_name) {
          case "category":
            ym(94760218,'reachGoal','category');
            break;
          case "education":
            ym(94760218,'reachGoal','education');
            break;
          case "geo":
            ym(94760218,'reachGoal','geo_quiz');
            break;
          case "program":
            ym(94760218,'reachGoal','program');
            break;
          default: console.log('no metricks');
        }
      }

      /* Переключение */
      slides[i].style.display = "none";
      slides[i + 1].style.display = "flex";
      resetCheked(i + 1);
    });
  }

  /* Сброс checked у следующего слайда */
  function resetCheked(number) {
    if (number < slides.length - 1) {
      slides[number].querySelector(".quiz__slide-btn").disabled = true;
      let radios = slides[number].querySelectorAll("input[type='radio']");

      for (let radio of radios) {
        if (radio.checked) {
          radio.checked = false;
          break;
        }
      }
    }
  }

  /* События на категории и уровень образования */
  (() => {
    const categories = document.querySelectorAll("input[name='category']");
    categories.forEach((input) => {
      input.addEventListener("change", () => {
        nextSlide(input.closest("form"));
        ym(94760218,'reachGoal','category');
      });
    });

    const educations = document.querySelectorAll("input[name='Education']");
    educations.forEach((input) => {
      input.addEventListener("change", (event) => {
        level = event.target.value;
        nextSlide(input.closest("form"));
        ym(94760218,'reachGoal','education');
      });
    });
  })();

  /* Рендеринг регионов в квиз */
  (async function renderRegionsQuiz() {
    const RegionsQuiz = document.getElementById("Regions-quiz");

    if (!RegionsQuiz) {
      return;
    }

    try {
      let data = "";
      requestPrograms.regions.forEach((item) => {
        data += `
          <div class="quiz__slide-form__checkbox">
            <input type="radio" name="Region" value="${item.name}" id="${item.id}">
            <label for="${item.id}">
              <span>${item.name}</span>
            </label>
          </div>
        `;
      });

      RegionsQuiz.innerHTML = data;

      const Regions = document.querySelectorAll("input[name='Region']");
      Regions.forEach((input) => {
        input.addEventListener("change", (event) => {
          ym(94760218,'reachGoal','geo_quiz');
          region = event.target.id;

          /* Фильтрация общего массива в зависимости от выбранного региона */
          allProgramsRegionFiltred = programs.filter((item) =>
            item.regions.some((it) => it.region_id == region)
          );

          /* Логика по отсеиванию программ с одинаковыми shortname, у которых нет в данном регионе задачи */
          filterNoDublicatePrograms = structuredClone(allProgramsRegionFiltred);
          
          /* Добавление в переменную всех возможных программ для данного региона для отслеживания логики вывода модального окна с нужным сообщением */
          allProgramsRegion = [];
          allProgramsRegion = structuredClone(filterNoDublicatePrograms);

          logicEducationFields();
          renderProgramsQuiz(filterPrograms);

          if (filterPrograms.length > 0) {
            nextSlide(input.closest("form"));
          } else {
            input
              .closest(".quiz__slide")
              .querySelector(".quiz__slide-btn").disabled = true;
            modalMissProgMain(allProgramsRegion);
          }
        });
      });
    } catch (e) {
      console.log(e);
    }
  })();

  /* Логика полей в зависимости от выбора уровня образования */
  function logicEducationFields() {
    if (level == 1) {      
      filterPrograms = filterNoDublicatePrograms.filter((item) => item.level == "vocational");
    } else {
      filterPrograms = filterNoDublicatePrograms;
    }
  }

  /* Рендеринг программ в квиз */
  function renderProgramsQuiz(programs) {
    const ProgramsQuiz = document.getElementById("Programs-quiz");

    let data = "";
    programs.forEach((item, index) => {
      data += `
        <div class="quiz__slide-form__checkbox">
          <input type="radio" id="program-${index + 1}" name="Program" value="${item.name}" shortname="${item.shortname}">
          <label for="program-${index + 1}">
            <span>${item.name}</span>
          </label>
        </div>
      `;
    });

    ProgramsQuiz.innerHTML = data;

    const Programs = document.querySelectorAll("input[name='Program']");
    Programs.forEach((input) => {
      input.addEventListener("change", (e) => {
        let data = getDataProgram(filterNoDublicatePrograms, e, region, true);

        /* Добавление аттрибута ссылки на РВР */
        e.target.setAttribute(
          'linkrvr', data?.link
        );
        
        /* Добавление аттрибута оператора */
        e.target.setAttribute(
          'operator', data?.operator
        );
        
        /* Добавление аттрибута id программы */
        e.target.setAttribute(
          'program_id', data?.program_id
        );

        
        nextSlide(input.closest("form"));
        ym(94760218,'reachGoal','program');
      });
    });
  }

  /* Модальное окно об отсутствии программ для Главной страницы */
  function modalMissProgMain(arr) {
    let Modal = document.getElementById("QuizModal");

    if (!Modal) {
      Modal = document.createElement("div");
      Modal.classList.add("custom-modal__hidden", "modal-programs");
      Modal.id = "QuizModal";
      document.body.append(Modal);
    }

    if (arr.length == 0) {
      Modal.innerHTML = `<div class="modal-programs__content">
        <div style="text-align: center"><img width="58" src="/img/pages/quiz/modal.png" alt="icon"/></div>
        <h3 style="text-align: center">К сожалению, по данному региону нет доступных программ</h3>
        <p style="text-align: center">Попробуйте выбрать другой регион или зайдите позже, чтобы узнать о&nbsp;наличии новых программ</p>
      </div>`;
      modal.openModal("QuizModal");
    } else {
      Modal.innerHTML = `<div class="modal-programs__content">
        <div style="text-align: center"><img width="58" src="/img/pages/quiz/modal.png" alt="icon"/></div>
        <h3 style="text-align: center">К сожалению, по выбранному уровню образования нет доступных программ</h3>
        <p style="text-align: center">Попробуйте зайти позже, чтобы узнать о&nbsp;наличии новых программ</p>
      </div>`;
      modal.openModal("QuizModal");
    }
  }
};

export default quiz;
